export enum CreditScoreColors {
  GREY = 'Grey',
  GREEN = 'Green',
  YELLOW = 'Yellow',
  ORANGE = 'Orange',
  RED = 'Red',
  TEAL = 'Teal',
  BLUE = 'Blue',
  DARK_BLUE = 'Dark Blue',
  DEFAULT = 'Default',
}
